<template>
  <div class="home">
    <el-row :gutter="15">
      <!-- 
      <el-col
        :span="24 / (loginType == 'merchantLogin' ? cards : cuCards).length"
        v-for="(t, i) in loginType == 'merchantLogin' ? cards : cuCards"
        :key="i"
      >
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t(t.title) }}</span>
            <i
              v-if="t.isMoney"
              :class="showAmounts ? 'el-icon-view' : 'el-icon-lock'"
              style="float: right; cursor: pointer; margin-left: 6px; color: #909399;"
              @click="showAmounts = !showAmounts"
              :title="$t(showAmounts ? 'hide' : 'show')"
            ></i>
            <el-tag
              v-if="t.tagShow"
              style="float: right; height:18px;line-height:18px"
              >{{ $t("today") }}</el-tag
            >
          </div>
          <div v-if="t.isMoney" class="exhibition">
            <span class="franc">FCFA</span>
            <template v-if="showAmounts">{{
              t.content.formatMoney(0)
            }}</template>
            <template v-else>••••••</template>
          </div>
          <div v-else class="exhibition">{{ t.content }}</div>
        </el-card>
      </el-col>
    -->
      <el-col
        :span="24 / (loginType == 'merchantLogin' ? cards : cuCards).length"
        v-for="(t, i) in loginType == 'merchantLogin' ? cards : cuCards"
        :key="i"
      >
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t(t.title) }}</span>
            <el-tag
              v-if="t.tagShow"
              style="float: right; height:18px;line-height:18px"
              >{{ $t("today") }}</el-tag
            >
            <i
              v-if="t.isMoney"
              :class="
                hiddenCards[t.title] === false ? 'el-icon-view' : 'el-icon-lock'
              "
              style="float: right; cursor: pointer; margin: 0 6px; color: #909399; line-height: 18px;"
              @click="toggleCardVisibility(t.title)"
            ></i>
          </div>
          <div v-if="t.isMoney" class="exhibition">
            <span class="franc">FCFA</span>
            <template v-if="hiddenCards[t.title] === false">{{
              t.content.formatMoney(0)
            }}</template>
            <template v-else>••••••</template>
          </div>
          <div v-else class="exhibition">{{ t.content }}</div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" class="residual-space">
      <el-col :span="16" style="height:100%">
        <el-card
          class="box-card"
          shadow="never"
          :body-style="{
            padding: '15px 0',
            height: '100%',
            overflow: 'hidden'
          }"
        >
          <div slot="header" class="clearfix">
            <span>{{ $t("recent trading record") }}</span>
          </div>
          <div class="table-is-page" :style="{ height: `calc(100% - 70px)` }">
            <el-table
              :data="transactionRecord"
              style="width:100%"
              size="mini"
              height="100%"
            >
              <el-table-column
                prop="createTime"
                :label="$t('tradingTime')"
                width="160"
              >
                <template slot-scope="scope">
                  {{ $manba(scope.row.createTime).format("ymdhms") }}
                </template>
              </el-table-column>
              <el-table-column
                prop="businessName"
                :label="$t('dealType')"
                min-width="120"
              >
                <template slot-scope="scope">
                  {{ $t(scope.row.businessName) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                :label="$t('transactionAmount')"
                min-width="140"
              >
                <template slot-scope="scope">
                  <span class="franc">FCFA</span>
                  {{ scope.row.amount ? scope.row.amount.formatMoney(0) : 0 }}
                </template>
              </el-table-column>
              <el-table-column prop="status" :label="$t('status')" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0" class="text-info">{{
                    $t("await")
                  }}</span>
                  <span v-if="scope.row.status == 1" class="text-primary">{{
                    $t("trading")
                  }}</span>
                  <span v-if="scope.row.status == 2" class="text-success">{{
                    $t("completeTransaction")
                  }}</span>
                  <span v-if="scope.row.status == 3" class="text-danger">{{
                    $t("failureTransaction")
                  }}</span>
                  <span v-if="scope.row.status == 4" class="text-warning">{{
                    $t("reversaling")
                  }}</span>
                  <span v-if="scope.row.status == 5" class="text-danger">{{
                    $t("completeReversal")
                  }}</span>
                  <span v-if="scope.row.status == 6" class="text-danger">{{
                    $t("failureReversal")
                  }}</span>
                </template>
              </el-table-column>
              <!--<el-table-column prop="regionName" :label="$t('region')" min-width="120"></el-table-column>-->
              <el-table-column
                prop="region"
                :label="$t('region')"
                min-width="160"
              >
                <template slot-scope="scope">{{
                  formatRegion(scope.row.region)
                }}</template>
              </el-table-column>
              <el-table-column
                prop="orgName"
                :label="$t('org')"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="transactionCode"
                :label="$t('Transaction no.')"
                min-width="120"
              >
              </el-table-column>
              <el-table-column
                prop="createRemark||remark"
                :label="$t('explain')"
                min-width="200"
              >
                <template slot-scope="scope">
                  <div class="overstep-hidden">
                    <translation
                      v-if="scope.row.createRemark"
                      :text="scope.row.createRemark"
                    />
                    <translation
                      v-if="scope.row.remark"
                      :text="scope.row.remark"
                    />
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
      <!-- 通知 -->
      <el-col :span="8" style="height:100%">
        <el-card
          class="box-card"
          shadow="never"
          :body-style="{ padding: '0', height: 'calc(100% - 56px)' }"
        >
          <div slot="header" class="clearfix">
            <span>{{ $t("notification") }}</span>
          </div>
          <div
            class="infinite-list"
            style="height:100%;overflow:auto"
            v-infinite-scroll="loadNotifications"
            :infinite-scroll-distance="100"
          >
            <ul class="notification-list">
              <li
                v-for="(t, i) in notifications.list"
                :key="i"
                class="notification-item"
                @click="increase(t)"
              >
                <div class="item-left">
                  <div class="item-title overstep-hidden1">{{ t.title }}</div>
                  <div class="item-content overstep-hidden1">
                    {{ t.content }}
                  </div>
                </div>
                <div class="item-right">
                  <div class="item-datetime">
                    {{ $manba(t.createTime).format("ymdhms") }}
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('clickNumber')"
                    placement="top-end"
                  >
                    <span
                      ><i class="iconfont icondianji"></i>
                      {{ t.browseNum || 0 }}</span
                    >
                  </el-tooltip>
                </div>
              </li>
            </ul>
            <p
              v-if="notifications.loading"
              style="text-align: center;color: #aaa;"
            >
              {{ $t("loading") }}
            </p>
            <p
              v-if="notifications.noMore"
              style="text-align: center;color: #aaa;"
            >
              {{ $t("noMore") }}
            </p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      :title="notifications.dialog.title"
      :visible.sync="notifications.dialog.visible"
      width="600px"
      top="20vh"
      destroy-on-close
      :modal-append-to-body="false"
      center
      custom-class="custom-dialog"
    >
      <p>{{ notifications.dialog.content }}</p>

      <span slot="footer" class="dialog-footer">
        <el-button @click="notifications.dialog.visible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import translation from "../../components/specialTranslation.vue";

import message from "@/api/message";
import card from "@/api/card";
import home from "@/api/home";
import customerBusiness from "@/api/customerBusiness";
import transactionInfo from "@/api/transactionInfo";
import country from "@/api/country";

import storage from "@/assets/uilt/storage";

export default {
  // name: "home",
  components: { translation },
  data() {
    return {
      cards: [
        { title: "cardNumber", content: "--" },
        { title: "commissionAmount", content: 0, isMoney: true },
        { title: "cashAmount", content: 0, isMoney: true },
        { title: "businessStatistics", content: 0 }
      ],

      cuCards: [
        { title: "cardNumber", content: "--" },
        { title: "commissionAmount", content: 0, isMoney: true },
        { title: "businessStatistics", content: 0 }
      ],

      notifications: {
        list: [],
        noMore: false,
        loading: false,
        current: 0,
        dialog: {
          visible: false,
          title: "",
          content: ""
        }
      },

      loginType: "merchantLogin",
      showAmounts: false,
      showAmounts2: false,
      hiddenCards: {},

      /**30条最近交易记录 */
      transactionRecord: []
    };
  },
  computed: {
    countryList() {
      return this.$store.state.globalParameter.countryList;
    }
  },
  watch: {},
  methods: {
    toggleCardVisibility(title) {
      if (this.hiddenCards[title] === false) {
        this.$set(this.hiddenCards, title, true);
      } else {
        this.$set(this.hiddenCards, title, false);
      }
    },
    formatRegion(region) {
      let p1 = this.countryList.find(function(c) {
        return c.id == region;
      });
      let p2 = this.countryList.find(function(c) {
        return c.id == p1.parentId;
      });
      return p2.name + "/" + p1.name;
    },
    getCountry() {
      let _this = this;
      country.getList({
        success: res => {
          _this.$set(_this, "countryList", res.data);
        }
      });
    },
    /**机构账户登录查询交易记录 */
    getTransactionRecord() {
      let _this = this;
      transactionInfo.getPage({
        param: { size: 30 },
        success: function(res) {
          _this.transactionRecord = res.data ? res.data.records : [];
        }
      });
    },
    /**个人账户登录查询交易记录 */
    cuGetTransactionRecord() {
      let _this = this;
      customerBusiness.listCardFlow({
        param: { size: 30 },
        success: function(res) {
          _this.transactionRecord = res.data ? res.data.records : [];
        }
      });
    },
    /**查询通知 */
    getNotifications() {
      let _this = this;
      _this.notifications.loading = true;
      let pageSize = 3;
      message.getPage({
        param: {
          current: _this.notifications.current,
          size: pageSize,
          status: 0
        },
        success: res => {
          if (res.code == 200)
            _this.notifications.list.push(...res.data.records);

          if (!res.data || res.data.length < pageSize)
            _this.notifications.noMore = true;

          _this.notifications.loading = false;
        }
      });
    },
    loadNotifications() {
      if (this.notifications.noMore || this.notifications.loading) return;
      this.notifications.current++;
      this.getNotifications();
    },
    /**增加浏览次数 */
    increase(row) {
      this.notifications.dialog = { visible: true, ...row };

      message.browseMessageById({
        param: { id: row.id },
        success: res => {
          if (res.code == 200) row.browseNum++;
        }
      });
    },

    /**个账户以外的信息查询 */
    /** 
    getHeaderData() {
      card.getCardAccount({
        success: (res) => {
          if (res.code == 200) {
            const roleName = this.$store.state.globalParameter.loginInfo?.job;
            const isAdmin = roleName === "ADMINISTRATEUR";
            // NEW: for ADMINISTRATEUR, add total advanced customer balance card
            if (isAdmin) {
              card.getAdvancedCustomerTotal({
                success: (res3) => {
                  if (res3.code == 200) {
                    this.cards.splice(3, 0, {
                      title: "partnersRemainingBalance",
                      content: res3.data || 0,
                      isMoney: true,
                    });
                  }
                },
              });

              // NEW: monthly remuneration card
              transactionInfo.getMonthlyRemunerationTotal({
                success: (res4) => {
                  if (res4.code == 200) {
                    this.cards.splice(4, 0, {
                      title: "monthlyRemuneration",
                      content: res4.data || 0,
                      isMoney: true,
                    });
                  }
                },
              });
            } else {
              this.cards = [
                { title: "cardNumber", content: res.data.cardNo || "--" },
                {
                  //title: "commissionAmount",
                  title: isAdmin ? "monthlyRemuneration" : "commissionAmount",
                  content: res.data.accountAmount || 0,
                  isMoney: true,
                },
                /*{
                title: "cashAmount",
                content: res.data.cashAmount || 0,
                isMoney: true,
              },*/
    /*
                {
                  title: isAdmin ? "partnersRemainingBalance" : "cashAmount",
                  content: res.data.cashAmount || 0,
                  isMoney: true,
                },
                /*
              ...(res.data.orgType !== 3
                ? [
                    {
                      title: "cashAmount",
                      content: res.data.cashAmount || 0,
                      isMoney: true,
                    },
                  ]
                : []),*/
    /*
                { title: "businessStatistics", content: 0, tagShow: true },
              ];
            }

            this.$store.dispatch(
              "globalParameter/setCardInfo",
              JSON.parse(JSON.stringify(res.data)),
            );
          }
          

          home.countToday({
            success: (res2) => {
              let bs = this.cards.find(function(t) {
                return t.title == "businessStatistics";
              });
              bs.content = res2.data || 0;

              this.$store.dispatch(
                "globalParameter/setCardInfo",
                JSON.parse(JSON.stringify(res.data)),
              );
            },
          });
        },
      });
    },
    */

    getHeaderData() {
      card.getCardAccount({
        success: res => {
          if (res.code != 200) return;

          const isAdmin =
            this.$store.state.globalParameter.loginInfo?.job ===
            "ADMINISTRATEUR";

          if (isAdmin) {
            // Build admin cards
            this.cards = [
              { title: "cardNumber", content: res.data.cardNo || "--" },
              { title: "monthlyRemuneration", content: 0, isMoney: true },
              { title: "partnersRemainingBalance", content: 0, isMoney: true },
              { title: "businessStatistics", content: 0, tagShow: true }
            ];

            // Fetch monthly remuneration total
            transactionInfo.getMonthlyRemunerationTotal({
              success: res4 => {
                if (res4.code == 200) {
                  let card1 = this.cards.find(
                    t => t.title === "monthlyRemuneration"
                  );
                  if (card1) card1.content = res4.data || 0;
                }
              }
            });

            // Fetch partner remaining balance
            card.getAdvancedCustomerTotal({
              success: res3 => {
                if (res3.code == 200) {
                  let card2 = this.cards.find(
                    t => t.title === "partnersRemainingBalance"
                  );
                  if (card2) card2.content = res3.data || 0;
                }
              }
            });
          } else {
            // Non-admin cards
            this.cards = [
              { title: "cardNumber", content: res.data.cardNo || "--" },
              {
                title: "commissionAmount",
                content: res.data.accountAmount || 0,
                isMoney: true
              },
              {
                title: "cashAmount",
                content: res.data.cashAmount || 0,
                isMoney: true
              },
              { title: "businessStatistics", content: 0, tagShow: true }
            ];
          }

          this.$store.dispatch(
            "globalParameter/setCardInfo",
            JSON.parse(JSON.stringify(res.data))
          );

          // Business statistics (both admin and non-admin get this)
          home.countToday({
            success: res2 => {
              let bs = this.cards.find(t => t.title === "businessStatistics");
              if (bs) bs.content = res2.data || 0;
            }
          });
        }
      });
    },
    /**客户(个人) 查询 */
    getCustomerHeaderData() {
      let _this = this;
      customerBusiness.getCardAccount({
        success: res => {
          if (res.code == 200) {
            let cards = [
              { title: "cardNumber", content: res.data.cardNo || "--" },
              {
                title: "accountAmount",
                content: res.data.accountAmount || 0,
                isMoney: true
              },
              ...(res.data.orgType !== 3
                ? [
                    {
                      title: "cashAmount",
                      content: res.data.cashAmount || 0,
                      isMoney: true
                    }
                  ]
                : []),
              { title: "businessStatistics", content: 0, tagShow: true }
            ];

            customerBusiness.countToday({
              success: res2 => {
                let bs = _this.cuCards.find(function(t) {
                  return t.title == "businessStatistics";
                });
                bs.content = res2.data || 0;

                _this.$set(_this, "cuCards", cards);
                _this.$store.dispatch(
                  "globalParameter/setCardInfo",
                  JSON.parse(JSON.stringify(res.data))
                );
              }
            });
          }
        }
      });
    }
  },
  mounted() {
    let loginType = storage.local.get("loginName");
    /**缓存里没有登录类型跳转到机构登录页面 */
    if (!loginType) {
      this.$router.push({ name: "merchantLogin" });
    } else if (loginType.name === "merchantLogin") {
      this.getHeaderData();
      this.getTransactionRecord();
      this.loginType = loginType.name;
    } else if (loginType.name === "customerLogin") {
      this.getCustomerHeaderData();
      this.cuGetTransactionRecord();
      this.loginType = loginType.name;
    }

    this.getTransactionRecord();
  }
};
</script>
<style lang="less">
.home {
  i {
    font-size: 14px;
  }
  .residual-space {
    margin-top: 15px;
    position: absolute;
    top: 155px;
    bottom: 0;
    left: 0;
    right: 0;
    .el-col {
      height: 100%;
    }
    .el-card {
      height: 100%;
    }
  }
  .custom-dialog {
    color: red;
    .el-dialog__body {
      padding: 0 20px;
      p {
        letter-spacing: 1.5px;
        line-height: 24px;
      }
    }
  }
  .exhibition {
    font-size: 20px;
    font-weight: bold;
    line-height: 65px;
    text-align: right;
    .franc {
      font-size: 28px;
      font-weight: 100;
    }
  }
  .infinite-list {
    .notification-list {
      // margin: 0 -10px;
      .notification-item {
        height: auto;
        line-height: 28px;
        padding: 5px 15px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        .item-left {
          margin-right: 140px;
        }
        .item-right {
          position: absolute;
          top: 5px;
          right: 15px;
          text-align: right;
        }
        .item-left .item-content,
        .item-right .item-datetime {
          color: @info;
          font-size: 12px;
        }
      }
      .notification-item:hover {
        background-color: @french_grey;
      }
      .overstep-hidden1 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
